define(function (require, exports, module) {
    return {
        init: function (settings) {
            var prop;
            for (prop in settings) {
                this[prop] = settings[prop];
            }
        },
        update: function (settings) {
            var prop;
            for (prop in settings) {
                this[prop] = settings[prop];
            }
        }
    };
});
